<template>
  <div class="feedback">
    <modal-card>
      <div>
        <h1>Commentaires</h1>

        <div v-if="rink">
          <md-chip>{{ rink.name }}</md-chip>
        </div>

        <md-field>
          <label>Écrivez vos commentaires ici</label>
          <md-textarea v-model="feedback"></md-textarea>
        </md-field>
      </div>

      <template v-slot:actions>
        <md-button
          class="md-fab md-mini md-primary button-right"
          @click="saveFeedback"
        >
          <md-icon>send</md-icon>
        </md-button>
      </template>
    </modal-card>
  </div>
</template>

<style scoped>
h1 {
  font-family: "Staatliches", cursive;
  font-size: 2.5em;
  line-height: 0.9em;
  margin: 0;
  margin-bottom: 20px;
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 1em;
}
a {
  color: #000 !important;
  font-weight: bold;
  font-family: "Staatliches", cursive;
  font-size: 1.4em;
}
</style>

<script>
import firebase from "firebase/app";
import { EventBus } from "../main";
import dayjs from "dayjs";
import ModalCard from "../components/ModalCard";

export default {
  name: "feedback",
  head: {
    title: {
      inner: "Commentaires"
    },
    link: [{ rel: "canonical", href: "https://patinoires.ca/commentaires" }]
  },
  components: {
    ModalCard
  },
  data: () => ({
    showDialog: false,
    feedback: "",
    rink: null
  }),
  mounted() {
    try {
      this.rink = EventBus.getRink(this.$route.query.patinoire);
    } catch (e) {
      // console.log(e);
    }
  },
  methods: {
    saveFeedback() {
      let obj = {};
      obj.text = this.feedback;
      obj.rink = this.$route.query.patinoire || null;
      obj.archived = false;
      obj.timestamp = dayjs().toISOString();
      obj.uid = firebase.auth().currentUser.uid;
      firebase
        .database()
        .ref("/feedback/")
        .push(obj);

      this.$router.push("/");
    }
  }
};
</script>
